// src/app/u2104Organization/components/form/u2104Role/U2104UseGetOrganizatonRoleHandlers.ts
export interface U2104UseGetOrganizatonRoleHandlersParams<T = any> {
  doGetFn: (id: string, roleId: string) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for useU2104UseGetOrganizatonRoleHandlers hook
export interface U2104UseGetOrganizatonRoleHandlersReturn {
  getOrganizationRole: (id: string, roleId: string) => void;
}

// Handlers for getting organization role
export function useU2104UseGetOrganizatonRoleHandlers<T extends { id: string } = any>({
  doGetFn,
  onSuccess,
  onError,
}: U2104UseGetOrganizatonRoleHandlersParams<T>): U2104UseGetOrganizatonRoleHandlersReturn {
  const getOrganizationRole = async (id: string, roleId: string) => {
    try {
      const response = await doGetFn(id, roleId);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getOrganizationRole };
}
